import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Asset 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={228.323}
      height={220}
      viewBox="0 0 228.323 228.105"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={1.199}
          y1={-0.175}
          x2={3.03}
          y2={-1.743}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#09005d" />
          <stop offset={1} stopColor="#1a0f91" />
        </linearGradient>
        <linearGradient
          id="prefix__g"
          x1={0.507}
          y1={1.254}
          x2={0.501}
          y2={0.475}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fee543" />
          <stop offset={1} stopColor="#ffd200" />
        </linearGradient>
        <linearGradient
          id="prefix__h"
          x1={-53.88}
          y1={4.474}
          x2={-53.864}
          y2={8.118}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__b"
          x1={-170.33}
          y1={1.164}
          x2={-170.593}
          y2={-0.58}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#a22b25" />
          <stop offset={1} stopColor="#c0423c" />
        </linearGradient>
        <linearGradient
          id="prefix__i"
          x1={-96.482}
          y1={3.704}
          x2={-96.454}
          y2={7.136}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__j"
          x1={-189.399}
          y1={1.13}
          x2={-189.684}
          y2={-0.791}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__c"
          x1={0.385}
          y1={1.047}
          x2={0.658}
          y2={-0.106}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#4f52ff" />
          <stop offset={1} stopColor="#4042e2" />
        </linearGradient>
        <linearGradient
          id="prefix__k"
          x1={32.704}
          y1={-6.62}
          x2={1.032}
          y2={0.382}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__l"
          x1={-47.634}
          y1={0.5}
          x2={-46.634}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__m"
          x1={-25.507}
          y1={0.5}
          x2={-24.507}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__n"
          x1={-94.7}
          y1={1.029}
          x2={-93.411}
          y2={0.223}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__o"
          x1={-76.675}
          y1={0.175}
          x2={-77.992}
          y2={1.493}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__p"
          x1={-241.752}
          y1={2.763}
          x2={-238.491}
          y2={0.44}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__d"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#febbba" />
          <stop offset={1} stopColor="#ff928e" />
        </linearGradient>
        <linearGradient
          id="prefix__q"
          x1={0.532}
          y1={0.006}
          x2={0.327}
          y2={3.201}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__r"
          x1={0.989}
          y1={-2.927}
          x2={0.83}
          y2={-1.786}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__s"
          x1={0.554}
          y1={-2.159}
          x2={0.395}
          y2={6.279}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__e"
          x1={-0.189}
          y1={-0.253}
          x2={1.073}
          y2={1.106}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#e1473d" />
          <stop offset={1} stopColor="#e9605a" />
        </linearGradient>
        <linearGradient
          id="prefix__t"
          x1={1.793}
          y1={-1.366}
          x2={1.461}
          y2={-0.876}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__u"
          x1={0.705}
          y1={1.885}
          x2={0.475}
          y2={0.326}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__v"
          x1={-15.277}
          y1={13.064}
          x2={-13.845}
          y2={13.798}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__w"
          x1={0.088}
          y1={0.057}
          x2={2.144}
          y2={2.414}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__x"
          x1={-69.247}
          y1={40.843}
          x2={-63.056}
          y2={43.192}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__y"
          x1={0.623}
          y1={0.5}
          x2={1.623}
          y2={0.5}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__z"
          x1={0.854}
          y1={5.149}
          x2={0.113}
          y2={7.581}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__A"
          x1={0.733}
          y1={0.134}
          x2={0.333}
          y2={0.8}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__f"
          x1={6.351}
          y1={-48.345}
          x2={-0.119}
          y2={-37.87}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#cb236d" />
          <stop offset={1} stopColor="#4c246d" />
        </linearGradient>
        <linearGradient
          id="prefix__B"
          x1={-0.219}
          y1={-34.25}
          x2={-4.218}
          y2={-27.11}
          xlinkHref="#prefix__f"
        />
        <linearGradient
          id="prefix__C"
          x1={-10.4}
          y1={0.411}
          x2={-10.167}
          y2={2.003}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__D"
          x1={3.302}
          y1={-0.85}
          x2={2.146}
          y2={-0.265}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__E"
          x1={-0.475}
          y1={-5.679}
          x2={0.675}
          y2={1.419}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__F"
          x1={-13.383}
          y1={-6.096}
          x2={-14.121}
          y2={-3.634}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__G"
          x1={-11.233}
          y1={0.133}
          x2={-11.631}
          y2={0.802}
          xlinkHref="#prefix__a"
        />
      </defs>
      <g data-name="Layer 2">
        <path
          data-name="Path 3555"
          d="M218.605 154.515c-23.1 53.6-84.078 76.622-131.855 72.693-13.045-1.072-39.293-3.229-59.786-22.467-39.356-36.943-33.299-114.168 4.381-159.637C36.197 39.248 69.781.019 122.115.544c38.317.384 65.21 21.87 68.481 24.547a105 105 0 0121.455 24.164c19.294 29.952 20.99 71.766 6.554 105.26z"
          fill="none"
        />
        <path
          data-name="Path 3556"
          d="M1.015 25.453c-.632-1.026.687-2.288 1.905-1.829 12.365 4.655 43.641 20.514 51.568 63.784 9.948 54.289 28.753 69.045 48.165 75.4 0 0-23.191 1.691-43.035-13.028C10.895 113.637 12.256 43.699 1.015 25.453z"
          fill="#4d7c1b"
        />
        <path
          data-name="Path 3557"
          d="M13.818 40.211c3.14 5.367 6.154 10.8 8.929 16.332q4.214 8.281 7.825 16.818c2.378 5.7 4.63 11.445 6.6 17.291 2 5.835 3.7 11.761 5.384 17.718a167.284 167.284 0 005.83 17.749 55.374 55.374 0 009.993 16.161c1.086 1.194 2.2 2.371 3.392 3.473a71.772 71.772 0 003.639 3.249 66.839 66.839 0 008.055 5.76 73.456 73.456 0 0018.784 7.888 1.536 1.536 0 001.772-.822 1.081 1.081 0 00-.734-1.5c-1.605-.481-3.2-.978-4.759-1.537-.786-.268-1.554-.566-2.328-.856-.759-.314-1.537-.6-2.279-.935A66.606 66.606 0 0160.8 140.505a54 54 0 01-5.507-7.352 59.483 59.483 0 01-4.179-8.122 165.846 165.846 0 01-5.9-17.469c-1.774-5.929-3.619-11.867-5.737-17.712q-1.574-4.385-3.329-8.7c-.575-1.443-1.183-2.874-1.787-4.3q-.932-2.135-1.893-4.261-3.878-8.482-8.357-16.686c-3.02-5.451-6.207-10.813-9.634-16.04a.375.375 0 00-.5-.088.324.324 0 00-.151.44z"
          fill="#fff"
        />
        <path
          data-name="Path 3558"
          d="M49.946 109.053a2.372 2.372 0 01-3.892.6 72.334 72.334 0 01-17.884-59.48c3.826-26.821 3.352-41.728 2.669-48.48A1.487 1.487 0 0133.421.545C44.062 12.27 75.635 53.691 49.946 109.053z"
          fill="#a0d468"
        />
        <path
          data-name="Path 3559"
          d="M48.15 108.868a.657.657 0 01-.942-.379c-.125-.393-12.359-39.687-8.726-77.219a.658.658 0 111.309.127c-3.609 37.259 8.547 76.306 8.67 76.7a.656.656 0 01-.311.771z"
          fill="#fff"
        />
        <path
          data-name="Path 3560"
          d="M1040.8 2090.709c-.094-1.168-1.287-2.179-3.308-2.992 2.2-1.213 3.411-2.507 3.308-3.782-.31-3.851-12.507-6.01-27.242-4.823s-26.429 5.274-26.119 9.125c.094 1.167 1.288 2.179 3.308 2.992-2.2 1.213-3.41 2.508-3.308 3.781.094 1.169 1.287 2.18 3.308 2.993-2.2 1.214-3.41 2.507-3.308 3.781.094 1.168 1.287 2.18 3.308 2.993-2.2 1.213-3.41 2.507-3.308 3.781.138 1.7 2.6 3.073 6.582 3.973a34.162 34.162 0 00.1 4.16c.577 7.093 8.562 12.659 19.118 12.659s19.7-7.588 19.8-14.708a35.954 35.954 0 00-.206-4.645c5.051-1.687 8.128-3.748 7.967-5.747-.094-1.168-1.287-2.179-3.308-2.992 2.2-1.213 3.411-2.507 3.308-3.782-.094-1.168-1.287-2.179-3.308-2.992 2.198-1.204 3.408-2.502 3.308-3.775z"
          transform="translate(-906.305 -1907.931)"
          fill="#09005D"
        />
        <path
          data-name="Path 3561"
          d="M100.43 206.13a63.764 63.764 0 01-11.688-.956.354.354 0 11.133-.695 76.311 76.311 0 0019.47.615 83.67 83.67 0 0016.329-2.816.354.354 0 01.2.679 84.417 84.417 0 01-16.47 2.842 99.716 99.716 0 01-7.974.331z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3562"
          d="M100.518 199.353a55.615 55.615 0 01-14.351-1.556.354.354 0 01.194-.681c5.107 1.456 13.33 1.9 22 1.206 8.573-.69 16.569-2.426 21.39-4.654a.357.357 0 01.3.647c-4.891 2.255-12.978 4.018-21.63 4.716a100.2 100.2 0 01-7.903.322z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3563"
          d="M100.439 192.586c-6.139 0-11.511-.627-15.124-1.82a.354.354 0 01.222-.673c5.032 1.66 13.563 2.2 22.82 1.456 8.573-.691 16.569-2.431 21.389-4.655a.357.357 0 01.3.647c-4.892 2.255-12.977 4.019-21.63 4.717-2.747.216-5.428.328-7.977.328z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3564"
          d="M100.506 185.29a61.022 61.022 0 01-12.743-1.159.354.354 0 01.154-.69c5.176 1.151 12.634 1.448 20.455.817 8.5-.685 16.452-2.406 21.28-4.6a.355.355 0 01.293.647c-4.9 2.229-12.94 3.973-21.513 4.665-2.712.208-5.38.32-7.926.32z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3565"
          d="M480.133 145.867a49.834 49.834 0 00-8.924-17.423c-8.772-11.056-23.082-33.539-24.844-64.225C443.8 19.584 483.389-2.762 519.511.272s71.767 29.93 67.865 71.453c-2.4 25.55-16.7 44.929-27.349 56.059a59.133 59.133 0 00-14.194 25.153c-3.2 11.537-10.8 25.915-28.873 26.79-23.39 1.13-33.103-20.669-36.827-33.86z"
          transform="translate(-408.982 .001)"
          fill="#FEE543"
        />
        <path
          data-name="Path 3566"
          d="M114.246 172.511l12.639-82.207c.262-1.7 1.1-2.839 1.867-2.548s1.183 1.9.921 3.6c-.006.045-.016.1-.023.146l-14.4 81.443c-.108.612-.419 1-.7.864s-.396-.705-.304-1.298z"
          fill="#fff"
          opacity={0.7}
        />
        <path
          data-name="Path 3567"
          d="M100.754 173.176L88.115 90.969c-.26-1.7-1.1-2.839-1.867-2.547s-1.183 1.9-.921 3.6l.024.145 14.4 81.443c.109.612.42 1 .695.864s.398-.707.308-1.298z"
          fill="#fff"
          opacity={0.7}
        />
        <path
          data-name="Path 3568"
          d="M126.608 82.512a1.326 1.326 0 00-1.658-.431l-7.037 3.289-2.443-6.96a1.494 1.494 0 00-.856-.861 1.739 1.739 0 00-2.163.667l-.012.023-5.789 10.553-5.372-15.023-.008-.024a1.719 1.719 0 00-.814-.917 2.109 2.109 0 00-2.658.523L89.71 84.49a.976.976 0 00.285 1.405 1.357 1.357 0 001.721-.187l7.124-7.947 6.414 14.291.005.01a1.13 1.13 0 00.566.554 1.34 1.34 0 001.678-.434l6.19-9.933 2.329 5.024.021.045a1.066 1.066 0 00.058.107 1.327 1.327 0 001.658.43l8.354-3.9a.994.994 0 00.495-1.443z"
          fill="#fff"
        />
        <path
          data-name="Path 3571"
          d="M1591.809 2661.425a30.245 30.245 0 00-.366 3.188 1.375 1.375 0 001.237 1.448c2.56.249 8.386.707 12.107.17a.624.624 0 00.343-1.074 19.33 19.33 0 00-11.336-4.817z"
          transform="translate(-1461.065 -2442.45)"
          fill="#09005D"
        />
        <path
          data-name="Path 3572"
          d="M1580.29 2617.552l1.294 3.171a1.059 1.059 0 001.085.656 5.748 5.748 0 001.057-.2 1.39 1.39 0 00.924-1.728l-.976-3.267z"
          transform="translate(-1450.899 -2401.861)"
          fill="url(#prefix__b)"
        />
        <path
          data-name="Path 3573"
          d="M1259.942 2705a13.615 13.615 0 013.6 4.95 1.182 1.182 0 01-1.123 1.57h-5.333a1.258 1.258 0 01-1.243-1.47c.34-1.921 1.32-5.042 4.099-5.05z"
          transform="translate(-1152.982 -2483.498)"
          fill="#09005D"
        />
        <path
          data-name="Path 3574"
          d="M1267 2665.605s.524 2.318.926 3.848a.49.49 0 00.641.335 4.457 4.457 0 011.941-.353.378.378 0 00.417-.376l.05-3.849z"
          transform="translate(-1163.263 -2446.926)"
          fill="url(#prefix__j)"
        />
        <path
          data-name="Path 3575"
          d="M1220.807 1957.335l15.763 48.089s-3.023 1.98-4.464 1.9l-18.723-38.646s-3.276 23.812-1.689 40.908l-5.363.409s-8.719-43.689-2.115-58.653z"
          transform="translate(-1103.156 -1790.791)"
          fill="#4F52FF"
        />
        <path
          data-name="Path 3576"
          d="M1345.167 2101.941h-.019a.152.152 0 01-.132-.169l.611-4.853a.153.153 0 11.3.038l-.613 4.853a.153.153 0 01-.147.131z"
          transform="translate(-1234.909 -1925.1)"
          fill="url(#prefix__k)"
        />
        <path
          data-name="Path 3577"
          d="M120.631 123.326s-12.771 1.132-10.964 10.234a124.026 124.026 0 00-10.36 28.935.92.92 0 00.746 1.094l21.27 3.639a1.146 1.146 0 001.3-.842l5.081-19.639 1.98 9.131 6.292-1.639-5.3-26.831s-.737-3.914-10.045-4.082z"
          fill="#91b3fa"
        />
        <path
          data-name="Path 3578"
          d="M127.939 145.749h-.034a.162.162 0 01-.121-.188l1.772-8.142a.162.162 0 11.31.067l-1.773 8.141a.162.162 0 01-.154.122z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3579"
          d="M1416.7 1921.337a3.026 3.026 0 00-2.2-.286l-1.48.368a.535.535 0 01-.662-.46l-1.532-13.629a12.547 12.547 0 01-5.588.733l3.525 16.068h12.337z"
          transform="translate(-1290.105 -1751.052)"
          fill="#A22B25"
        />
        <path
          data-name="Path 3580"
          d="M1615.534 1609.632l-.373-1.239a2.45 2.45 0 00-1.432-1.568l-6.742-2.712s-.1-.864 1.424-1.455a2.031 2.031 0 001.169-2.3s-2.085.952-5.138 2.46a7.144 7.144 0 00-3.245 3.533l-15.278 18.624 1.794 1.234a4.79 4.79 0 006.944-1.7l8.276-15.871a30.86 30.86 0 0012.601.994z"
          transform="translate(-1455.863 -1469.149)"
          fill="#A22B25"
        />
        <path
          data-name="Path 3581"
          d="M1480.5 1393.364l-3.928 10.994s3.478 2.72 6.016 1.8l1.979-6.3s-1.513-7.703-4.067-6.494z"
          transform="translate(-1355.647 -1279.106)"
          fill="#A22B25"
        />
        <path
          data-name="Path 3582"
          d="M1559.207 1321.162c0 .169-3.784 10.711-3.784 10.711l-5.973-2.289 2.1-10.524s7.657-.729 7.657 2.102z"
          transform="translate(-1422.545 -1210.931)"
          fill="url(#prefix__o)"
        />
        <path
          data-name="Path 3583"
          d="M130.062 110.694l-1.541 5.453a.767.767 0 00-.03.213c0 .445.11 1.976 1.669 1.767a7.114 7.114 0 013.531.048.79.79 0 01.4.983 34.021 34.021 0 01-2.152 4.853.79.79 0 01-1.016.323 25.558 25.558 0 01-5.121-3.012.794.794 0 01-.281-.76c.262-1.4 1.042-5.638 1.077-6.855.032-1.141-1.249-2.012-1.812-2.339a.781.781 0 01-.367-.493 2.054 2.054 0 011.793-2.763.794.794 0 00.647-.943 2.055 2.055 0 011.546-2.647 2.9 2.9 0 013.305 1.319.793.793 0 00.984.264.626.626 0 01.7.126.78.78 0 001.141-.174 2.361 2.361 0 012.912-.962c2.7.874 2.57 3.985 1.581 5.676s-3.862.579-5.221-.542c-1.034-.852-2.608-.343-3.3-.049a.783.783 0 00-.445.514z"
        />
        <path
          data-name="Path 3584"
          d="M1513.346 1362.379s1.6-3.021.541-3.97-2.846-.793-2.8 1.57c.06 2.938 2.259 2.4 2.259 2.4z"
          transform="translate(-1387.371 -1246.687)"
          fill="url(#prefix__p)"
        />
        <path
          data-name="Path 3585"
          d="M116.28 156.983a15.394 15.394 0 01-1.561-.074l-.114-.013-4.65-21.681a.162.162 0 01.31-.066l4.6 21.457c.692.061 4.387.306 6.339-1.075l-4.029-18.837.84-1.584a.162.162 0 11.28.148l-.787 1.482 4.044 18.925-.081.061c-1.404 1.057-3.676 1.257-5.191 1.257z"
          fill="#7d97f4"
        />
        <path
          data-name="Rectangle 309"
          fill="#91b3fa"
          d="M199.506 196.845h2.293v24.797h-2.293z"
        />
        <path
          data-name="Path 3586"
          d="M210.694 222.12h-20.079v-.108a1.384 1.384 0 011.384-1.384h17.206a1.492 1.492 0 011.489 1.492z"
          fill="#91b3fa"
        />
        <rect
          data-name="Rectangle 310"
          width={25.251}
          height={7.162}
          rx={3.581}
          transform="translate(188.424 191.289)"
          fill="#91b3fa"
        />
        <path
          data-name="Path 3587"
          d="M2145.81 2195.69a19.964 19.964 0 00-7.239 3.088 1.911 1.911 0 00-.843 1.826 80.981 80.981 0 008.564 26.881 2.892 2.892 0 01.278 1.983l-1.081 5.03-2 1.879h5.161l3.438-9.3-1.47-.465a2.78 2.78 0 01-1.941-2.6l-.173-9.976a11.356 11.356 0 00-2.725-7.511l8.242-.4z"
          transform="translate(-1962.561 -2015.379)"
          fill="url(#prefix__d)"
        />
        <path
          data-name="Path 3588"
          d="M2183.839 2588.444c-.471.615 5.059 1.427 7.852.081 0 0 3.872-6.737 3.872-10.206 0 0-.307-.707-2.582-.547 0 0-1.3 7.978-2.673 8.872s-3.841.091-3.841.091a8.036 8.036 0 00-2.628 1.709z"
          transform="translate(-2004.929 -2366.538)"
          fill="url(#prefix__q)"
        />
        <path
          data-name="Path 3589"
          d="M1935.414 2221.218c-.043-.077-8.875-1.062-8.875-1.062a20.432 20.432 0 01-.614 6.381c-.9 3.7-13.869 19.709-13.869 19.709l1.36 4.311a21.873 21.873 0 01-12.406.745l8.425-5.056s7.885-26.871 12.715-31.664l8.852-3.063z"
          transform="translate(-1745.06 -2029.928)"
          fill="url(#prefix__d)"
        />
        <path
          data-name="Path 3590"
          d="M2196.47 2138.11s5.088 7.568 5.506 11.02-1.394 4.853-6.732 5.085-19.59.229-19.59.229l-12.163-10.4s8.864-3.162 11.168-4.057 21.811-1.877 21.811-1.877z"
          transform="translate(-1985.776 -1962.928)"
          fill="url(#prefix__r)"
        />
        <path
          data-name="Path 3591"
          d="M1885.917 2676.24a2.485 2.485 0 01.475 2.992s-11.594 2.056-14.742 1.123c0 0 .653-1.492 4.2-3.19l-.262.2a.423.423 0 00.28.76c2.332-.131 7.168-.558 10.049-1.885z"
          transform="translate(-1718.308 -2457.063)"
          fill="url(#prefix__s)"
        />
        <path
          data-name="Path 3592"
          d="M2318.876 1586.994c.794-.132 3.72-.492 4.2 1.261a.324.324 0 00.534.149c.921-.825 3.094-2.374 5.476-1.281 2.1.965 1.908 2.975 1.546 4.206a.328.328 0 00.494.372c1.835-1.237 6.066-3.443 8.773.195 2.527 3.4.467 5.748-.921 6.818a.323.323 0 00.173.582 3.478 3.478 0 013.047 2.82c1 3.39-5.215 6.208-5.948 6.526a.318.318 0 01-.145.026l-12.563-.647a.323.323 0 01-.247-.133l-7.707-10.382a.33.33 0 01-.051-.292l3.083-10a.324.324 0 01.258-.222z"
          transform="translate(-2125.511 -1456.692)"
          fill="url(#prefix__w)"
        />
        <path
          data-name="Path 3593"
          d="M2281.655 1813.941a115.718 115.718 0 01-8.841-9.382 7.923 7.923 0 01-1.342-7.135 98.52 98.52 0 013.913-9.855c.331-1.109 6.974-1.063 6.974-1.063s13.073 8.484 18.209 22.856l-5.769 1.8a67.29 67.29 0 00-6.785-9.367s5.836 7.709 6.042 10.865z"
          transform="translate(-2084.72 -1640.026)"
          fill="url(#prefix__t)"
        />
        <path
          data-name="Path 3594"
          d="M2313.68 1712.924c.069.23 1.8 5.979 1.941 6.1s3.8.316 5.529-.863l-2.928-6.129z"
          transform="translate(-2123.819 -1571.835)"
          fill="url(#prefix__u)"
        />
        <path
          data-name="Path 3595"
          d="M2245.746 1605.363s-1.448 3.073-.01 7.863 4.015 5.281 5.692 4.161a9.343 9.343 0 004.269-7.43c.403-4.285-7.968-8.478-9.951-4.594z"
          transform="translate(-2060.785 -1472.437)"
          fill="url(#prefix__v)"
        />
        <path
          data-name="Path 3596"
          d="M2218.762 1550.587s-2.662-6.5-7.082-2.643l-.384 1.64s-4.051-1.294-2.592-4.957 6.289-6.562 10.588-4.024 5.832 5.954 5.491 9.319-2.83 2.132-2.83 2.132-.408-2.5-1.582-2.974-1.208 1.4-1.208 1.4z"
          transform="translate(-2027.042 -1413.525)"
          fill="url(#prefix__w)"
        />
        <path
          data-name="Path 3597"
          d="M2343.332 1654.63s-1.387-3.334.705-3.388 1.139 3.208.685 4.4z"
          transform="translate(-2150.658 -1516.044)"
          fill="url(#prefix__x)"
        />
        <path
          data-name="Path 3598"
          d="M2251.9 2074.144l4.353-4.2 6.022 2.544s5.994.928 9.425 0l3.431-.929 7.753-2.414 1.214 3.441a2.071 2.071 0 01-.757 2.38 13.508 13.508 0 01-1.958 1.22c-1.02.447-25.167-.309-25.167-.309z"
          transform="translate(-2067.035 -1899.71)"
          fill="url(#prefix__y)"
        />
        <path
          data-name="Path 3599"
          d="M2155.091 2129.313h-.058l-25.251-.028a1.132 1.132 0 010-2.264l25.251.028a1.132 1.132 0 01.055 2.259z"
          transform="translate(-1953.754 -1952.888)"
          fill="url(#prefix__z)"
        />
        <path
          data-name="Path 3600"
          d="M1842.9 1871.88h21.028a4.007 4.007 0 013.625 2.3l9.72 20.615h-26.132a2.436 2.436 0 01-2.265-1.54l-7.538-19.076a1.679 1.679 0 011.563-2.3z"
          transform="translate(-1690.16 -1718.447)"
          fill="#09005D"
        />
        <path
          data-name="Path 3601"
          d="M167.401 163.944c.456 1.417.119 2.792-.751 3.073s-1.947-.64-2.4-2.055-.119-2.791.752-3.073 1.947.64 2.399 2.055z"
          fill="#91b3fa"
        />
        <path
          data-name="Path 3602"
          d="M228.304 177.395a.93.93 0 00-.219-.809 1.076 1.076 0 00-.809-.355H121.701a1.226 1.226 0 00-1.013.518 1.063 1.063 0 00-.081 1.077l1.144 2.317a1.613 1.613 0 001.456.87h103.348a1.2 1.2 0 001.192-.919z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3603"
          d="M123.137 228.105a.852.852 0 01-.364-.081 1.048 1.048 0 01-.486-1.326l19.394-49.208a.9.9 0 011.213-.528 1.049 1.049 0 01.485 1.326l-19.393 49.208a.925.925 0 01-.849.609z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3604"
          d="M145.019 228.105a.924.924 0 01-.85-.611l-19.394-49.208a1.045 1.045 0 01.485-1.326.9.9 0 011.213.529l19.395 49.208a1.046 1.046 0 01-.486 1.326.853.853 0 01-.363.082z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3605"
          d="M203.555 228.105a.858.858 0 01-.365-.081 1.048 1.048 0 01-.485-1.326l19.394-49.208a.9.9 0 011.213-.528 1.048 1.048 0 01.485 1.326l-19.394 49.208a.925.925 0 01-.848.609z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3606"
          d="M225.4 228.105a.924.924 0 01-.85-.611l-19.4-49.208a1.047 1.047 0 01.486-1.326.9.9 0 011.213.529l19.393 49.208a1.044 1.044 0 01-.485 1.326.855.855 0 01-.357.082z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 3607"
          d="M33.377 97.858s-2.878 1.4-3.407 3.007c-.425 1.29-3.606 1.456-3.921 3.993a2.911 2.911 0 01-2.436 2.559c-3.25.5-8.257 2.184-9.058 7.827-.611 4.307 1.584 5.939 3.888 6.505a3.263 3.263 0 012.475 3.769c-.328 1.639.162 3.534 3 5.031 6.362 3.356 12.715-7.953 12.715-7.953l1.3-19.751z"
        />
        <path
          data-name="Path 3608"
          d="M68.555 93.105s-12.7 20.09-27.806 23.972c0 0 2.943 8.382 5.215 9.341 0 0 18.582-15.505 23.357-30.458z"
          fill="#f7b686"
        />
        <path
          data-name="Path 3609"
          d="M7.23 2709.167l-.412 3.384a1.4 1.4 0 01-1.226 1.223 21.638 21.638 0 01-4.529.072 1.2 1.2 0 01-1.005-1.553 12.321 12.321 0 012.27-4.421h3.754a1.156 1.156 0 011.148 1.3z"
          transform="translate(-.001 -2486.136)"
          fill="#09005D"
        />
        <path
          data-name="Path 3610"
          d="M36.632 183.387l.634 3.728s-2.122 21.493-2.5 30.09a6.739 6.739 0 001 3.83l3.69 5.991-9.377-5.534-.187-1.144 1.537-2.11-2.01-24.078a7.4 7.4 0 01.84-4.087l1.941-3.639z"
          fill="#f7b686"
        />
        <path
          data-name="Path 3611"
          d="M371.4 2682.9h-2.992a1.8 1.8 0 01-1.43-.7c-.933-1.213-2.866-3.577-3.79-3.639-1.245-.082-1.085 4.34-1.085 4.34h-.7l-.88-5.493a3.256 3.256 0 011.7-3.4 4.6 4.6 0 001.827 3.034c1.542.931 6.275 4.261 6.275 4.261a4.289 4.289 0 011.213.032.791.791 0 01-.138 1.565z"
          transform="translate(-331.329 -2455.005)"
          fill="#09005D"
        />
        <path
          data-name="Path 3612"
          d="M23.789 185.157s-12.432 23.581-14.407 28.964a51.693 51.693 0 00-2.695 10.3c-.041.665-.868 1.3-3.146 1.3a2.187 2.187 0 01-2.034-.927 1.327 1.327 0 01-.05-1.286c.719-1.456 3-6.106 3.847-8.216 1.009-2.518 3.179-13.931 4.367-17.9s2.535-8.272 7.72-12.238c.002.003 3.56-3.481 6.398.003z"
          fill="#f7b686"
        />
        <path
          data-name="Path 3613"
          d="M335.356 1454.8c3.207-13.587-4.916-21.271-4.916-21.271 5.126-4.92 14.465-7.158 14.465-7.158s8.911 6.515 7.854 11.614c-.62 2.992-6.264 17.9-6.264 17.9a12.407 12.407 0 01-11.139-1.085z"
          transform="translate(-303.715 -1309.394)"
          fill="#4F52FF"
        />
        <path
          data-name="Path 3614"
          d="M217.7 1784.606c1.3-3.931 7.109-6.726 7.109-6.726a12.4 12.4 0 0011.138 1.085 22.34 22.34 0 01.362 8.632c-.808 4.158-5.876 30.878-5.876 30.878-7.987 1.617-20.268-1.628-20.268-1.628 5.091-9.033 6.235-28.309 7.535-32.241z"
          transform="translate(-193.172 -1631.961)"
          fill="#4F52FF"
        />
        <path
          data-name="Path 3615"
          d="M35.364 107.735l-2.608 11.71c-.25 1.032.691.863 1.733.666 1.708-.323 3.91-.985 4.645-2.314a1.249 1.249 0 00.133-.442l1.12-8.12a1.456 1.456 0 00-.854-1.537l-2.161-.958a1.455 1.455 0 00-2.008.994z"
          fill="#f7b686"
        />
        <path
          data-name="Path 3616"
          d="M40.357 96.931s2.775 1.879 3.968 6.663-.746 6.5-2.732 6.4a9.21 9.21 0 01-7.36-4.152c-2.492-3.437 2.485-11.207 6.124-8.911z"
          fill="#f7b686"
        />
        <path
          data-name="Path 3617"
          d="M36.747 103.866s-1.017-6.856 4.675-5.807l1.151 1.2s2.786-3.137-.3-5.509-7.36-1.765-9.729 2.553-3.227 7.352-1.242 10.035 3.478.382 3.478.382-.91-2.322-.155-3.316 1.729.579 1.729.579z"
        />
        <path
          data-name="Path 3618"
          d="M35.969 104.51s-.5-3.528-2.3-2.519.647 3.295 1.631 4.073z"
          fill="#f7b686"
        />
        <path
          data-name="Path 3619"
          d="M68.743 97.014c.038.415-1.5.7-1.994-1.066.135-.767.375-4.124.962-4.647a61.974 61.974 0 018.719-5.9 1.142 1.142 0 01-.195 1.582l-2.789 1.882a11.262 11.262 0 01.763 2.912 3.263 3.263 0 01-.826 2.281 28.408 28.408 0 01-1.975 2.074 3.218 3.218 0 01-2.665.882z"
          fill="#f7b686"
        />
        <path
          data-name="Path 3620"
          d="M837.687 1104.067l-.426-.175a23.79 23.79 0 012.042-4.066.993.993 0 00.353-.653.46.46 0 00-.143-.287l-2.258 1.207-1 1.56-.389-.248 1.062-1.662 2.643-1.413.119.1a1 1 0 01.421.718 1.369 1.369 0 01-.481 1 22.913 22.913 0 00-1.943 3.919z"
          transform="translate(-767.431 -1008.396)"
          fill="url(#prefix__E)"
        />
        <path
          data-name="Path 3621"
          d="M415.758 1842.774h.053l23.292-.025a1.032 1.032 0 100-2.063l-23.292.025a1.031 1.031 0 10-.051 2.062z"
          transform="translate(-381.211 -1689.996)"
          fill="url(#prefix__F)"
        />
        <path
          data-name="Path 3622"
          d="M614.338 1607.809h-19.4a3.7 3.7 0 00-3.344 2.1l-8.967 18.814h24.1a2.246 2.246 0 002.093-1.4l6.955-17.41a1.537 1.537 0 00-1.442-2.1z"
          transform="translate(-534.838 -1476.038)"
          fill="#09005D"
        />
        <ellipse
          data-name="Ellipse 134"
          cx={2.46}
          cy={1.527}
          rx={2.46}
          ry={1.527}
          transform="rotate(-71.76 131.929 26.787)"
          fill="#91b3fa"
        />
        <path
          data-name="Path 3623"
          d="M26.69 124.225c-3.178 3.207-7.21 17.421-5.21 19.794 1.762 2.764 7.759 6.526 13.47 6.532h8.428c-3.541-3.762-5.978-4.716-8.882-2.086-2.3-.984-5.291-4.8-7.285-6.5a2.125 2.125 0 01-.444-2.694c1.584-2.682 3.571-5.439 4.206-8.109.132-3.13-2.18-6.711-4.283-6.937z"
          fill="#f7b686"
        />
        <path
          data-name="Path 3624"
          d="M141.044 174.053a1.278 1.278 0 00-1.278-1.278h-19.245a.924.924 0 00-.865.451 3.484 3.484 0 00.013 2.8.837.837 0 00.781.41h19.315a1.278 1.278 0 001.278-1.278z"
          fill="#91b3fa"
        />
        <path
          data-name="Path 3625"
          d="M120.666 176.073l2.345-.089c.292-.011.521-.182.521-.39v-1.962c0-.211-.235-.384-.532-.39l-2.311-.053a.544.544 0 00-.555.306 3.765 3.765 0 00-.028 2.281.554.554 0 00.56.297z"
          fill="#fff"
          opacity={0.53}
        />
        <path
          data-name="Path 3626"
          d="M124.573 175.922c.288-.015.512-.185.512-.39v-1.877c0-.219-.253-.395-.561-.391-.3 0-.538.178-.538.391v1.877c-.003.224.267.403.587.39z"
          fill="#fff"
          opacity={0.53}
        />
        <g data-name="Group 268" opacity={0.3}>
          <path
            data-name="Path 3627"
            d="M172.534 28.334a.842.842 0 01.389-1.057 33.958 33.958 0 012.593-1.229.841.841 0 011.1.446l.007.015a.841.841 0 01-.453 1.088 32.29 32.29 0 00-2.465 1.169.841.841 0 01-1.137-.352l-.034-.08zm6.826-2.678a.985.985 0 01-.032-.095.843.843 0 01.594-1.032c.922-.248 1.86-.46 2.8-.629a.842.842 0 01.3 1.656c-.891.162-1.784.362-2.66.6a.842.842 0 01-1.003-.5zm7.246-1.108a.841.841 0 01.748-1.154 33.475 33.475 0 012.869.011.842.842 0 11-.081 1.681 31.74 31.74 0 00-2.725-.011.84.84 0 01-.811-.527zm7.312.54a.842.842 0 01.938-1.14c.938.177 1.878.4 2.8.653a.841.841 0 11-.453 1.618 32.285 32.285 0 00-2.656-.62.841.841 0 01-.629-.511zm7.009 2.157a.842.842 0 011.117-1.085c.872.379 1.741.8 2.58 1.254a.842.842 0 01-.8 1.482c-.8-.431-1.623-.832-2.451-1.193a.837.837 0 01-.446-.458zm6.357 3.654a.841.841 0 011.278-.992 34.21 34.21 0 012.239 1.795.842.842 0 11-1.109 1.267c-.682-.6-1.4-1.169-2.127-1.7a.841.841 0 01-.281-.37zm13.337 27.881a.829.829 0 01-.058-.351c.04-.9.043-1.821.005-2.726a.842.842 0 011.682-.069c.04.954.037 1.92-.006 2.871a.842.842 0 01-1.623.275zm-7.949-22.913a.842.842 0 011.418-.864 32.797 32.797 0 011.779 2.248.842.842 0 11-1.363.988 31.364 31.364 0 00-1.692-2.134.875.875 0 01-.146-.238zm7.454 15.6a.847.847 0 01-.048-.162 33.278 33.278 0 00-.6-2.66.842.842 0 011.624-.442c.25.92.464 1.86.635 2.8a.842.842 0 01-1.609.465zm-3.316-9.551a.842.842 0 011.526-.707c.446.841.861 1.712 1.234 2.588l.007.016a.842.842 0 01-1.557.642 32.015 32.015 0 00-1.172-2.46.684.684 0 01-.039-.08z"
          />
          <path
            data-name="Path 3628"
            d="M219.817 64.636a.849.849 0 01-.04-.5c.1-.423.188-.855.269-1.284a.842.842 0 011.654.311c-.081.451-.179.906-.282 1.351a.841.841 0 01-1.6.123z"
          />
        </g>
        <g data-name="Group 269" opacity={0.3}>
          <path
            data-name="Path 3629"
            d="M204.75 86.116a.841.841 0 01.348-1.033c.373-.223.746-.458 1.111-.7a.842.842 0 11.925 1.407c-.384.252-.777.5-1.169.734a.842.842 0 01-1.155-.29.832.832 0 01-.06-.118z"
          />
          <path
            data-name="Path 3630"
            d="M157.457 70.241q-.216-.539-.416-1.089a.842.842 0 011.583-.573c.307.847.647 1.68 1.017 2.484a.842.842 0 11-1.53.7c-.226-.5-.447-1.008-.654-1.522zm-1.641-5.36a.86.86 0 01-.041-.137 32.97 32.97 0 01-.478-2.784.841.841 0 011.669-.214c.114.882.267 1.772.455 2.645a.842.842 0 01-1.6.491zm4.416 10.771a.842.842 0 011.492-.764c.478.75.994 1.489 1.536 2.2a.842.842 0 11-1.337 1.024 35.276 35.276 0 01-1.618-2.316.832.832 0 01-.071-.142zm-5.148-17.955a.858.858 0 01-.06-.324c.009-.938.058-1.887.146-2.82a.842.842 0 111.676.162c-.081.89-.132 1.787-.139 2.679a.842.842 0 01-1.624.3zm9.675 23.567a.842.842 0 011.375-.911c.63.626 1.293 1.234 1.981 1.807a.842.842 0 11-1.082 1.29c-.72-.6-1.421-1.243-2.085-1.9a.84.84 0 01-.189-.287zm5.648 4.486a.841.841 0 011.228-1.026c.755.474 1.536.923 2.328 1.332a.844.844 0 01-.774 1.5c-.831-.431-1.656-.9-2.449-1.4a.833.833 0 01-.333-.4zm6.49 3.149a.842.842 0 011.063-1.105c.841.3 1.7.566 2.564.793a.842.842 0 01-.43 1.627 35.658 35.658 0 01-2.7-.835.843.843 0 01-.5-.478zm7.022 1.658a.842.842 0 01.884-1.148c.885.107 1.784.179 2.674.212a.842.842 0 11-.062 1.682 33.623 33.623 0 01-2.816-.224.841.841 0 01-.681-.52zm7.219.075a.819.819 0 01-.056-.229.841.841 0 01.752-.922 32.11 32.11 0 002.654-.382.841.841 0 11.309 1.654c-.923.173-1.859.308-2.794.4a.842.842 0 01-.866-.523zm7.053-1.511l-.018-.048a.842.842 0 01.534-1.064 32.115 32.115 0 002.51-.95.843.843 0 011.105.444.834.834 0 01-.444 1.1q-.343.145-.69.285c-.639.256-1.294.5-1.951.714a.841.841 0 01-1.046-.483z"
          />
          <path
            data-name="Path 3631"
            d="M155.957 50.515a.835.835 0 01-.038-.505c.1-.443.22-.89.344-1.336a.842.842 0 011.618.453c-.119.421-.228.848-.324 1.269a.841.841 0 01-1.6.12z"
          />
        </g>
        <path
          data-name="Path 3632"
          d="M165.443 47.232a.392.392 0 00.052.454l3.206 3.559a20.87 20.87 0 00-.761 6.713l-3.914 2.75a.393.393 0 00-.152.431l1.59 5.513a.394.394 0 00.358.285l4.778.247a20.849 20.849 0 004.214 5.282l-.825 4.716a.394.394 0 00.2.413l5.027 2.779a.394.394 0 00.454-.053l3.559-3.205a20.838 20.838 0 006.713.76l2.75 3.915a.394.394 0 00.431.152l5.519-1.588a.394.394 0 00.284-.357l.247-4.778a20.87 20.87 0 005.282-4.214l4.716.824a.394.394 0 00.413-.2l2.779-5.026a.393.393 0 00-.052-.454l-3.205-3.559a20.859 20.859 0 00.76-6.713l3.915-2.75a.394.394 0 00.152-.43l-1.589-5.519a.394.394 0 00-.357-.284l-4.786-.247a20.851 20.851 0 00-4.214-5.282l.824-4.717a.392.392 0 00-.2-.412l-5.026-2.779a.392.392 0 00-.454.052l-3.551 3.2a20.847 20.847 0 00-6.713-.76l-2.75-3.915a.392.392 0 00-.43-.152l-5.523 1.592a.4.4 0 00-.283.358l-.248 4.778a20.849 20.849 0 00-5.282 4.214L168.634 42a.393.393 0 00-.412.2z"
          fill="#ff3539"
        />
        <path
          data-name="Path 3633"
          d="M183.537 59.714a5.773 5.773 0 11.372.762 5.662 5.662 0 01-.372-.762zm9.471-3.783a4.426 4.426 0 10-1.884 5.46 4.427 4.427 0 001.884-5.46z"
          fill="#fff"
        />
        <path
          data-name="Path 3634"
          d="M175.842 62.868a14.488 14.488 0 01-.473-1.38c-.042-.148-.083-.3-.12-.447a14.167 14.167 0 01-.383-2.241v-.031l-.007-.087-.012-.17a.336.336 0 11.671-.046 13.532 13.532 0 0017.231 12.085q.669-.193 1.316-.452a13.521 13.521 0 10-14.934-21.77.337.337 0 01-.492-.459 14.2 14.2 0 11-2.79 15z"
          fill="#fff"
        />
        <g data-name="Group 270" opacity={0.3}>
          <path
            data-name="Path 3635"
            d="M140.523 9.926a.518.518 0 01.162-.6 22.85 22.85 0 011.069-.791.52.52 0 11.593.854 24.16 24.16 0 00-1.02.754.52.52 0 01-.729-.087.511.511 0 01-.075-.13z"
          />
          <path
            data-name="Path 3636"
            d="M143.878 7.752a.522.522 0 01.243-.653 22.831 22.831 0 012.076-.958q.223-.088.449-.174a.537.537 0 01.67.3.519.519 0 01-.3.67l-.429.162a21.713 21.713 0 00-1.982.914.519.519 0 01-.7-.219.228.228 0 01-.027-.042zm5.052-1.9a.67.67 0 01-.024-.071.521.521 0 01.383-.628 22.479 22.479 0 012.724-.485.52.52 0 11.119 1.033 21.5 21.5 0 00-2.6.464.519.519 0 01-.602-.315zm5.362-.62a.53.53 0 01-.037-.2.52.52 0 01.525-.515 22.406 22.406 0 012.762.2.52.52 0 01-.139 1.027 21.263 21.263 0 00-2.633-.188.521.521 0 01-.478-.326zm5.35.717a.526.526 0 01-.02-.324.52.52 0 01.635-.37 22.55 22.55 0 012.629.866.52.52 0 11-.386.966 21.445 21.445 0 00-2.507-.827.523.523 0 01-.351-.311zm5.014 2a.52.52 0 01.733-.647 22.663 22.663 0 012.338 1.478.52.52 0 11-.609.843 21.708 21.708 0 00-2.232-1.412.524.524 0 01-.233-.262zm4.375 3.158a.52.52 0 01.837-.575 22.359 22.359 0 011.9 2 .521.521 0 01-.8.668 21.324 21.324 0 00-1.818-1.91.528.528 0 01-.129-.186zm3.469 4.13a.52.52 0 01.919-.476 22.717 22.717 0 011.357 2.412.52.52 0 01-.937.454 21.486 21.486 0 00-1.294-2.3.543.543 0 01-.049-.09zm3.063 7.467a.565.565 0 01-.027-.088 21.489 21.489 0 00-.589-2.219 8.197 8.197 0 00-.108-.324.52.52 0 01.982-.34c.04.115.081.23.115.346a22.6 22.6 0 01.615 2.324.52.52 0 01-.991.3z"
          />
        </g>
        <g data-name="Group 271" opacity={0.3}>
          <path
            data-name="Path 3637"
            d="M133.586 35.609a.52.52 0 01.964-.392 21.466 21.466 0 001.139 2.332.52.52 0 11-.9.512 22.5 22.5 0 01-1.194-2.444zm-.872-2.512c-.006-.018-.013-.035-.018-.053a22.778 22.778 0 01-.579-2.66.52.52 0 011.028-.162 21.623 21.623 0 00.551 2.538.52.52 0 01-.982.335zm3.489 7.13a.519.519 0 01.9-.5 21.753 21.753 0 001.671 1.988.52.52 0 11-.754.716 22.363 22.363 0 01-1.75-2.084.484.484 0 01-.065-.116zm-4.3-12.374a.5.5 0 01-.037-.177 22.391 22.391 0 01.081-2.722.52.52 0 011.036.094 21.441 21.441 0 00-.081 2.6.52.52 0 01-1 .21zm7.956 16.225a.52.52 0 01.813-.6 21.216 21.216 0 002.1 1.528.52.52 0 11-.56.877 22.768 22.768 0 01-2.2-1.6.524.524 0 01-.154-.205zm4.47 2.857a.52.52 0 01.708-.662 21.779 21.779 0 002.4.983.52.52 0 11-.334.984 22.9 22.9 0 01-2.52-1.029.52.52 0 01-.255-.277zm5.028 1.706a.52.52 0 01.59-.7 21.24 21.24 0 002.569.377.52.52 0 01-.088 1.036 22.7 22.7 0 01-2.694-.395.522.522 0 01-.375-.316z"
          />
          <path
            data-name="Path 3638"
            d="M132.388 22.537a.523.523 0 01-.025-.3c.094-.434.2-.869.323-1.29a.52.52 0 011 .28c-.113.4-.215.816-.306 1.231a.52.52 0 01-.991.081z"
          />
        </g>
        <path
          data-name="Path 3639"
          d="M138.978 20.44a.263.263 0 00.035.3l2.146 2.379a13.939 13.939 0 00-.509 4.493l-2.62 1.841a.265.265 0 00-.1.288l1.064 3.693a.263.263 0 00.243.19l3.2.166a13.95 13.95 0 002.819 3.534l-.551 3.154a.26.26 0 00.132.276l3.363 1.86a.261.261 0 00.3-.035l2.377-2.143a13.93 13.93 0 004.493.509l1.84 2.62a.263.263 0 00.288.1l3.691-1.064a.263.263 0 00.19-.243l.166-3.2a13.949 13.949 0 003.534-2.819l3.154.552a.263.263 0 00.275-.132l1.86-3.363a.264.264 0 00-.035-.3l-2.145-2.379a13.924 13.924 0 00.509-4.493l2.62-1.84a.264.264 0 00.1-.288l-1.063-3.693a.263.263 0 00-.243-.19l-3.19-.159a13.962 13.962 0 00-2.823-3.539l.552-3.154a.263.263 0 00-.132-.275l-3.363-1.86a.263.263 0 00-.3.035l-2.38 2.145a13.971 13.971 0 00-4.493-.509l-1.84-2.62a.263.263 0 00-.288-.1l-3.686 1.064a.262.262 0 00-.19.243l-.162 3.2a13.944 13.944 0 00-3.534 2.819l-3.154-.552a.263.263 0 00-.276.132z"
          fill="#fb8145"
        />
        <path
          data-name="Path 3640"
          d="M150.953 28.378a3.952 3.952 0 11.256.523 4.07 4.07 0 01-.256-.523zm6.339-2.53a2.814 2.814 0 00-.186-.382 2.893 2.893 0 10-5 2.912 2.893 2.893 0 005.185-2.531z"
          fill="#fff"
        />
        <path
          data-name="Path 3641"
          d="M145.623 30.606a9.853 9.853 0 01-.678-2.905l-.006-.089a.522.522 0 01.323-.518.552.552 0 01.162-.036.52.52 0 01.553.485 8.743 8.743 0 00.323 1.836l.029.1a8.67 8.67 0 002.2 3.68 8.824 8.824 0 001.88 1.422l.017.01.052.028a8.7 8.7 0 006.657.752 8.753 8.753 0 00-4.842-16.822 8.488 8.488 0 00-.841.289 8.711 8.711 0 00-3.135 2.147.514.514 0 01-.188.126.52.52 0 01-.574-.837 9.762 9.762 0 013.508-2.4q.461-.184.941-.324a9.793 9.793 0 016.367 18.49 9.956 9.956 0 01-.953.323 9.807 9.807 0 01-11.795-5.757z"
          fill="#fff"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
